import { useCallback, useMemo } from 'react';
import useSwr from 'swr';
import { getCardData } from './card-data';

export interface IUseRecommendationsDataProps {
  entitySet: object;
  legacyConfig: object;
  jsdata: object;
  featureInstrumentation: object;
  instrumentationConstants: object;
  instrumentationLegacy: object;
  navigationLevel: string;
  campaignType: number;
  serverContext: object;
  permissions: object;
  cid: number;
  aid: number;
  campaignId: number;
  isMCC: boolean;
  guid: string;
  willFetchData: Function;
  onSuccess: () => void;
}

export function useRecommendationsData({
  entitySet,
  navigationLevel,
  featureInstrumentation,
  legacyConfig,
  campaignType,
  serverContext,
  jsdata,
  permissions,
  cid,
  aid,
  campaignId,
  instrumentationLegacy,
  instrumentationConstants,
  isMCC,
  guid,
  willFetchData,
  onSuccess,
}: IUseRecommendationsDataProps) {
  const fetch = useCallback(({
    navigationLevel, campaignType, cid, aid, campaignId, isMCC,
  }) => {
    willFetchData();
    return getCardData({
      entitySet,
      navigationLevel,
      featureInstrumentation,
      legacyConfig,
      campaignType,
      serverContext,
      jsdata,
      permissions,
      cid,
      aid,
      campaignId,
      instrumentationLegacy,
      instrumentationConstants,
      isMCC,
      guid,
    });
  }, [willFetchData, entitySet, featureInstrumentation, legacyConfig, serverContext,
    jsdata, permissions, instrumentationLegacy, instrumentationConstants, guid]);
  const swrKeyObject = useMemo(() => ({
    navigationLevel, campaignType, cid, aid, campaignId, isMCC,
  }), [aid, campaignId, campaignType, cid, isMCC, navigationLevel]);
  const {
    data, isLoading, mutate,
  } = useSwr(swrKeyObject, fetch, {
    revalidateOnFocus: false,
    onSuccess,
  });

  return {
    data,
    isLoading,
  };
}
